import { render } from "./AgentDetails.vue?vue&type=template&id=67831244&scoped=true"
import script from "./AgentDetails.vue?vue&type=script&lang=js"
export * from "./AgentDetails.vue?vue&type=script&lang=js"

import "./AgentDetails.vue?vue&type=style&index=0&id=67831244&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67831244"]])

export default __exports__